interface JSONCarrierAccountRegStatus {
  carrier_account: string;
  status: string;
}

enum RegStatus {
  PENDING_INFO = 'PENDING_INFO',
  PROCESSING = 'PROCESSING',
  COMPLETE = 'COMPLETE',
  OPTED_OUT = 'OPTED_OUT',
  ERROR = 'ERROR',
  PENDING_TERMS = 'PENDING_TERMS',
  UNDEFINED = 'UNDEFINED', // If an unexpected status is found fallback to UNDEFINED
}

type RegStatusByCarrierAccount = {
  [key: string]: RegStatus;
};

type IncompleteRegStatus = Exclude<RegStatus, RegStatus.COMPLETE>;

interface CarrierAccountRegStatus {
  carrierAccount: string;
  status: RegStatus;
}

function fromJSON(jsonRegStatus: JSONCarrierAccountRegStatus) {
  const serialized: CarrierAccountRegStatus = {
    carrierAccount: jsonRegStatus.carrier_account,
    status: RegStatus[jsonRegStatus.status as RegStatus] || RegStatus.UNDEFINED,
  };

  return serialized;
}

export default CarrierAccountRegStatus;
export {
  JSONCarrierAccountRegStatus,
  RegStatus,
  IncompleteRegStatus,
  fromJSON,
  RegStatusByCarrierAccount,
};
